import './components/checklist-increment';
import { checkBadWords } from './badword.js';
import { submitFormCheckBadWords } from './badword.js';

$(document).ready(function() {
    console.log('we are here');
    $('input[name=checklist-title], textarea[name=checklist-description]').on('focusout',function(e){
        var text = $(this).val();
        checkBadWords(text,this);
    });
    
    //dynamically added checklist items
    $('.checklist-container').on('focusout', 'input[name^=checklist-item], textarea[name^=checklist-item-note]', function(e) {
        var text = $(this).val();
        checkBadWords(text,this);
    });
    
    //checking on the submit form for badwords
    $('#form-create-checklist').on('submit', function(e){
        e.preventDefault();
        var submit_btn = $(this).find(':submit');
        submitFormCheckBadWords(this,e,submit_btn);
    });

    $('.checklist-submit').on('click', function(e){
        e.preventDefault();
        if ( grecaptcha.getResponse() !== 0 )   grecaptcha.execute();
    })

    if (!page_ajax.user_logged_in){
        var Checklist = {};

        $(".btn-submit").on("click", function(e){
            e.preventDefault();
            if ($('.imoment-error-field').length) {     
                var form = $('#form-create-checklist');
                // submitFormCheckBadWords(form,e,this);
                return false;   
            }
            //get all textbox input
            $('input[type=text]').each(function() {
                Checklist[$(this).attr('name')] = $(this).val();
            })

            //get all notes input
            $('textarea').each(function() {
                Checklist[$(this).attr('name')] = $(this).val();
            })

            //get checklist description
            Checklist[$('#checklist-description').attr('name')] = $('#checklist-description').val();
            
            // get due date
            Checklist[$('#checklist-due-date').attr('name')] = $('#checklist-due-date').val();
            
            // get if private or public
            if($('#checklist-status').is(':checked')){
                Checklist[$('#checklist-status').attr('name')] = "on";
            } else{
                Checklist[$('#checklist-status').attr('name')] = "off";
            }

            // store data in cookie
            sessionStorage.setItem("im_checklist_wo_login", JSON.stringify(Checklist));
            setCookie('im_checklist_wo_login',JSON.stringify(Checklist),1);
            // console.log(Checklist);
        })
        
    }

    function setCookie(name, value, days) {
        var expires = "";
        if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }
});